import { alawToPCM } from './g711.js'

let tempBuffers = new Float32Array(0)
export async function playG711Audio(g711Data, workletNode) {
  const buffer = await g711Data.arrayBuffer()

  // Decode G711 to PCM (assuming A-law)
  const pcmData = alawToPCM(new Uint8Array(buffer)) // Use your G711 A-law decoder

  const normalizedData = pcmToFloat32(pcmData)

  if (workletNode) {
    // Send PCM data in chunks to the worklet
    tempBuffers = concatFloat32Arrays([tempBuffers, normalizedData])
    if (tempBuffers.length % 128 === 0) {
      for (let i = 0; i < tempBuffers.length / 128; i++) {
        const chunk = tempBuffers.slice(i * 128, (i + 1) * 128)
        workletNode.port.postMessage(chunk)
      }
      tempBuffers = new Float32Array(0)
    }
  }
}

function concatFloat32Arrays(arrays) {
  const totalLength = arrays.reduce((acc, arr) => acc + arr.length, 0)
  const result = new Float32Array(totalLength)
  let offset = 0
  for (const arr of arrays) {
    result.set(arr, offset)
    offset += arr.length
  }
  return result
}

function pcmToFloat32(pcmData) {
  const normalizedData = new Float32Array(pcmData.length)
  for (let i = 0; i < pcmData.length; i++) {
    normalizedData[i] = pcmData[i] / 32768 // Convert Int16 to Float32 [-1, 1]
  }
  return normalizedData
}

export async function initWorklet() {
  const audioContext = new AudioContext({
    sampleRate: 8000,
  })

  // Load the worklet processor
  await audioContext.audioWorklet.addModule('/voip/g711-processor.js')

  const workletNode = new AudioWorkletNode(audioContext, 'g711-processor')

  const lowPassFilter = audioContext.createBiquadFilter()
  lowPassFilter.type = 'lowpass'
  lowPassFilter.frequency.value = 3000

  // Dynamics compressor to smooth out volume levels
  const compressor = audioContext.createDynamicsCompressor()
  compressor.threshold.setValueAtTime(-50, audioContext.currentTime)
  compressor.knee.setValueAtTime(40, audioContext.currentTime)
  compressor.ratio.setValueAtTime(12, audioContext.currentTime)
  compressor.attack.setValueAtTime(0, audioContext.currentTime)
  compressor.release.setValueAtTime(0.25, audioContext.currentTime)

  // Chain the nodes: Worklet -> Low-pass Filter -> Compressor -> Destination
  workletNode.connect(lowPassFilter)
  lowPassFilter.connect(compressor)
  compressor.connect(audioContext.destination)

  return workletNode
}
